/*
  Interface to Google Analytics tracking

  usage:

  ```
    import ga from './google-analytics'
    import router from './router'

    ga.use(router)
  ```

  help from following resources:
  * https://serversideup.net/google-analytics-vue-router-single-page-application/
  * https://gist.github.com/daliborgogic/91a01ff39ec2a30258b2a2fbe5555485
  * https://github.com/egoist/vue-ga
  * https://developers.google.com/analytics/devguides/collection/gtagjs/single-page-applications
*/

// custom Google Analytics tracking event
const gaNotLoaded = () => (window.gaTrackPageview === undefined);

const gaSetPageview = (url) => {
  window.gaTrackPageview(url);
};


const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

const trackNewPage = (url) => {
  if (isLocalhost || gaNotLoaded()) return;
  gaSetPageview(url);
};

const initialize = (router) => {
  // track a page after each route change
  router.afterEach((to) => {
    trackNewPage(to.path);
  });
};

export default {
  use: initialize,
};



// WEBPACK FOOTER //
// ./src/helpers/google-analytics.js